import { render } from "./EventSelector.vue?vue&type=template&id=52ba618c"
import script from "./EventSelector.vue?vue&type=script&lang=js"
export * from "./EventSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__